import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 7 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 7.20: requires signal AND zugmeldestelle.name in field 7.21
 * - Other aufträge (7.10, 7.25) have no content fields
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl7EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty using generic check
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules for 7.20
  const auftrag720 = findAuftrag(befehl, '7.20')
  if (auftrag720) {
    // If 7.20 exists and has fields, both signal AND zugmeldestelle must have content
    if (auftrag720.felder && auftrag720.felder.length > 0) {
      const hasSignal = hasFieldContent(auftrag720, '7.21', 'signal')
      const hasZugmeldestelle = hasFieldContent(
        auftrag720,
        '7.21',
        'zugmeldestelle.name'
      )
      const hasArt = hasFieldContent(auftrag720, '7.21', 'zugmeldestelle.art')
      if (!(hasSignal && hasZugmeldestelle && hasArt)) {
        return true
      }
    }
  }

  // All checks passed - no empty fields
  return false
}
